<template>
  <div class="mb-channel-dropdown" :class="{ open: isOpen }">
    <!-- 觸發列（顯示目前選中渠道） -->
    <div class="mb-cd-trigger" @click="$emit('update:is-open', !isOpen)">
      <img :src="selectedPayment.image" alt="">
      <div class="mb-cd-trigger-info">
        <span class="mb-cd-label">{{ selectedPayment.name }}</span>
        <span class="mb-cd-trigger-maint">{{ selectedPayment.announcement }}</span>

        <div
          v-if="selectedPayment.label && selectedPayment.label.length > 0"
          class="mb-cd-trigger-tags"
        >
          <span v-if="selectedPayment.label[0]" class="mb-cd-tag red">
            {{ selectedPayment.label[0] }}
          </span>
          <span v-if="selectedPayment.label[1]" class="mb-cd-tag">
            {{ selectedPayment.label[1] }}
          </span>
        </div>

        <span
          v-show="selectedPayment.code !== 'CcPayment' && selectedPayment.code !== 'AmoPay'"
          class="mb-cd-trigger-range"
        >
          {{ $t('Bao.min_to_max') }}
          <span class="secondary">
            {{ parseInt(selectedPayment.amount_limit_front.min) }} -
            {{ parseInt(selectedPayment.amount_limit_front.max) }}
          </span>
        </span>
      </div>
    </div>

    <!-- 下拉清單 -->
    <div class="mb-cd-list" :class="{ active: isOpen }">
      <template v-for="typeGroup in visibleTypeGroups">
        <div
          v-for="payment in typeGroup.paymentMethods"
          :key="payment.payment_id"
          class="mb-cd-item"
          :class="{ active: isSelectedPayment(payment) }"
          @click="onSelect(payment)"
        >
          <img :src="payment.image" alt="">
          <div class="mb-cd-item-info">
            <div class="mb-cd-item-top">
              <span class="mb-cd-item-name">{{ payment.name }}</span>
              <template v-if="payment.label && payment.label.length > 0">
                <span v-if="payment.label[0]" class="mb-cd-tag red">{{ payment.label[0] }}</span>
                <span v-if="payment.label[1]" class="mb-cd-tag">{{ payment.label[1] }}</span>
              </template>
            </div>
            <span
              v-show="payment.code !== 'CcPayment' && payment.code !== 'AmoPay'"
              class="mb-cd-item-range"
            >
              {{ $t('Bao.min_to_max') }}
              <span class="secondary">
                {{ parseInt(payment.amount_limit_front.min) }} -
                {{ parseInt(payment.amount_limit_front.max) }}
              </span>
            </span>
            <span class="mb-cd-item-maintenance">{{ payment.announcement }}</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DepositChannelDropdown',
  props: {
    /** 目前選中的渠道物件 */
    selectedPayment: {
      type: Object,
      required: true
    },
    /** 所有渠道群組（已篩選過） */
    filteredPaymentTypes: {
      type: Array,
      default: () => []
    },
    /** 是否為買幣模式（只顯示 type=4） */
    isBuyCrypto: {
      type: Boolean,
      default: false
    },
    /** 下拉開關狀態（.sync 用） */
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visibleTypeGroups() {
      return this.filteredPaymentTypes.filter(t => !this.isBuyCrypto || t.type === 4)
    }
  },
  methods: {
    isSelectedPayment(payment) {
      return this.selectedPayment && this.selectedPayment.payment_id === payment.payment_id
    },
    onSelect(payment) {
      this.$emit('update:is-open', false)
      this.$emit('select', payment)
    }
  }
}
</script>
